import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SiteHeader } from '../../components/layout/SiteHeader';
import { Button } from '../../components/ui/Button';
import { Input, Label } from '../../components/ui/Input';
import { useAuthStore } from '../../state/authStore';
import { t } from '../../i18n';
import './auth-page.css';

export default function LoginPage() {
  const navigate = useNavigate();
  const login = useAuthStore((s) => s.login);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [offline, setOffline] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    setOffline(false);
    const result = await login(email, password);
    setSubmitting(false);
    if (result.ok) {
      navigate('/projecten');
    } else {
      setOffline(result.offline);
      setError(
        result.offline ? t('auth.login.offlineNotice') : t('auth.errors.invalidCredentials'),
      );
    }
  };

  return (
    <div className="page-shell">
      <SiteHeader />
      <div className="centered-page">
        <div className="auth-card">
          <h1>{t('auth.login.title')}</h1>
          <p className="auth-card-subtitle">{t('auth.login.subtitle')}</p>

          {error ? (
            <div className={offline ? 'auth-notice' : 'auth-error'}>
              <span>{error}</span>
              {offline ? (
                <Button variant="secondary" size="sm" onClick={() => navigate('/projecten')}>
                  {t('auth.login.continueAsGuest')}
                </Button>
              ) : null}
            </div>
          ) : null}

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="field-group">
              <Label htmlFor="email">{t('auth.login.email')}</Label>
              <Input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="field-group">
              <Label htmlFor="password">{t('auth.login.password')}</Label>
              <Input
                id="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <Button type="submit" variant="primary" size="lg" disabled={submitting}>
              {submitting ? t('common.loading') : t('auth.login.submit')}
            </Button>
          </form>

          <div className="auth-footer">
            <Link to="/wachtwoord-vergeten">{t('auth.login.forgotPassword')}</Link>
            <span>
              {t('auth.login.noAccount')}{' '}
              <Link to="/registreren">{t('auth.login.registerCta')}</Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
